const sjson = require('secure-json-parse');

export class VueSearch {

    constructor(config)
    {

        var Plugin = {
            name: 'default',
            url: '',
            pageObject: {
                data: []
            },
            filters: [
                {
                    fields: [],
                    value: '',
                }
            ],
            sortField: '',
            sortDirection: '',
            perPageOptions: [
                2,
                20,
                50,
                100,
                200,
                500,
            ],
            page: 1,
            perPage: 20,
            isLoading: false,
            hasError: false,
            errorMsg: undefined,
            autoInit: true,
            withoutStorage: false,
            onStart: () => {},
            onSuccess: () => {},
            onError: () => {},
            onFinally: () => {},
        };
        Plugin = Object.assign(Plugin, config);

        var storage = Plugin.withoutStorage ? {} : sjson.parse(localStorage.getItem('search_' + Plugin.name) || '{}');
        Plugin = Object.assign(Plugin, storage);

        Plugin.search = function () {
            Plugin.onSuccess(Plugin);
            var promise = new Promise(function (resolve, reject) {
                Plugin.isLoading = true;
                Plugin.pageObject.data = [];
                Plugin.hasError = false;
                Plugin.errorMsg = undefined;

                var data = {
                    page: Plugin.page || 1,
                    perPage: Plugin.perPage || 20,
                    sortField: Plugin.sortField || undefined,
                    sortDirection: Plugin.sortDirection || undefined,
                    filters: Plugin.filters,
                };

                if (!Plugin.withoutStorage) {
                    localStorage.setItem('search_' + Plugin.name, JSON.stringify(data));
                }

                data.filters = data.filters.filter(item => item.fields.length > 0);

                $.ajax({
                    type: 'GET',
                    url: Plugin.url,
                    data: data,
                    success: function(data){
                        Plugin.pageObject = data;
                        resolve(Plugin.pageObject);
                    },
                    error: function (err) {
                        Plugin.hasError = true;
                        Plugin.errorMsg = err;
                        reject(err);
                    }
                });
            });

            promise
            .then(() => {
                Plugin.onSuccess(Plugin);
            })
            .catch(() => {
                Plugin.onError(Plugin);
            })
            .finally(function () {
                Plugin.isLoading = false;
                Plugin.onFinally(Plugin);
            });

            return promise;
        }

        Plugin.addFilterFields = function (fields, index) {
            Plugin.filters[index].fields = fields.map((field) => {

                if (typeof field !== 'object') {
                    field = {
                        fields: [field],
                        type: 'OrWhereLike',
                    };
                }

                return field;
            });
        }

        Plugin.resetFilter = function (index, value) {
            Plugin.filters[index].value = value || '';
        }

        Plugin.setSort = function (field, direction) {
            Plugin.sortField = field;
            Plugin.sortDirection = direction;
            this.search();
        }

        Plugin.gotoPage = function (pageNumber) {
            Plugin.page = pageNumber;
            Plugin.search();
        }

        if (Plugin.autoInit) {
            Plugin.search();
        }

        return Plugin;
    }

}
